import React from "react";
import ReactDOM from "react-dom";
import "./components/style/App.css";
import { BrowserRouter } from "react-router-dom";
import i18n from "./config/i18n";
import { Provider } from "react-redux";
import ProviderDarkMode from "react-use-dark-mode";
import Store from "./store/index";
import { I18nextProvider } from "react-i18next";
import "rsuite/dist/styles/rsuite-default.css";
import App from "./routes/App";

i18n.init({
  react: {
    useSuspense: false,
  },
});

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <ProviderDarkMode>
      <Provider store={Store}>
        <BrowserRouter>
          <App i18n={i18n} />
        </BrowserRouter>
      </Provider>
    </ProviderDarkMode>
  </I18nextProvider>,
  document.getElementById("root")
);
